export interface FormationOption {
  id: string;
  label: string;
  size: number;
  positions: Position[];
}

import { Position } from '../players/utils/playerUtils';

export const formations: FormationOption[] = [
  {
    id: '9-3-2-3',
    label: '3-2-3 (9-a-side)',
    size: 9,
    positions: [
      { id: 'GK', role: 'GK', x: 47, y: 5 },
      { id: 'LB', role: 'LB', x: 75, y: 25 },
      { id: 'CB', role: 'CB', x: 47, y: 25 },
      { id: 'RB', role: 'RB', x: 20, y: 25 },
      { id: 'CM1', role: 'CM', x: 35, y: 45 },
      { id: 'CM2', role: 'CM', x: 60, y: 45 },
      { id: 'LW', role: 'LW', x: 75, y: 70 },
      { id: 'ST', role: 'ST', x: 47, y: 75 },
      { id: 'RW', role: 'RW', x: 20, y: 70 },
    ],
  },
  {
    id: '9-2-3-3',
    label: '2-3-3 (9-a-side)',
    size: 9,
    positions: [
      { id: 'GK', role: 'GK', x: 47, y: 5 },
      { id: 'CB1', role: 'CB', x: 35, y: 25 },
      { id: 'CB2', role: 'CB', x: 60, y: 25 },
      { id: 'CM1', role: 'CM', x: 25, y: 45 },
      { id: 'CM2', role: 'CM', x: 47, y: 45 },
      { id: 'CM3', role: 'CM', x: 70, y: 45 },
      { id: 'LW', role: 'LW', x: 75, y: 70 },
      { id: 'ST', role: 'ST', x: 47, y: 75 },
      { id: 'RW', role: 'RW', x: 20, y: 70 },
    ],
  },
];
